import React from 'react'
import { connect } from 'react-redux'
import { Timeline, TimelineEvent } from 'react-event-timeline'
import { Icon, Modal, Label } from 'semantic-ui-react'
import { TimeLineStepCont } from './styled'

const Approvers = (props) => {
  const { approvers, trigger, status } = props

  return (
    <Modal
      size='tiny'
      trigger={trigger}
      header='GOA'
      actions={['Close']}
      content={
        approvers.length ?
          <TimeLineStepCont>
            <Timeline>
              {approvers.length &&
                approvers.map((item, i, array) => {
                  if (i !== (array.length - 1)) {
                    return (
                      <TimelineEvent
                        key={i}
                        collapsible={true}
                        showContent={true}
                        title={item.stepName}
                        contentStyle={{ padding: 0, margin: 0 }}
                        bubbleStyle={{ borderWidth: 0, marginLeft: 2 }}
                        titleStyle={{ fontWeight: 'bold', height: '2rem', display: 'flex', alignItems: 'center' }}
                        icon={<Label circular color={getColorGropStep(item, item.isCurrentStep)}>{i + 1}</Label>}
                      >
                        <Timeline>
                          {item.approval.map((iItem, ii) => {
                            return (
                              <TimelineEvent
                                className='tlCon'
                                key={ii}
                                collapsible={true}
                                showContent={true}
                                title={iItem.stepName}
                                contentStyle={{ padding: 0, margin: 0 }}
                                bubbleStyle={{ borderWidth: 0, marginLeft: 2 }}
                                titleStyle={iItem.position ? { fontWeight: 'bold' } : { fontWeight: 'bold', height: '2rem', display: 'flex', alignItems: 'center' }}
                                icon={<Label circular color={getColorInGroupStep(iItem, iItem.isCurrentStep)}><Icon name='thumbtack' /></Label>}
                              >
                                {iItem.approvers.map((iiItem, iii) => {
                                  return (
                                    <TimelineEvent
                                      key={iii}
                                      collapsible={true}
                                      showContent={true}
                                      title={<div className='displayName'><div>{iiItem.displayName}</div><div>{`${iiItem.position ? `(${iiItem.position})` : ''}`}</div></div>}
                                      bubbleStyle={{ borderWidth: 0, marginLeft: 2 }}
                                      titleStyle={iiItem.position ? { fontWeight: 'bold' } : { fontWeight: 'bold', height: '2rem', display: 'flex', alignItems: 'center' }}
                                      icon={<Label circular color={getColorUserStep(iiItem, iItem.isCurrentStep)}><Icon name='user' /></Label>}
                                    />
                                  )
                                })}
                              </TimelineEvent>
                            )
                          })}
                        </Timeline>
                      </TimelineEvent>
                    )
                  } else {
                    return (
                      <TimelineEvent
                        title='Complete'
                        createdAt=""
                        bubbleStyle={{ borderWidth: 0, marginLeft: 2 }}
                        titleStyle={{ fontWeight: 'bold', height: '2rem', display: 'flex', alignItems: 'center' }}
                        icon={<Label circular color={status === 4 ? 'green' : 'grey'}>{i + 1}</Label>}
                      />
                    )
                  }
                })
              }
            </Timeline>
          </TimeLineStepCont> : 'Not found'
      }
    />
  )

  function getColorGropStep(item, isCurrentStep) {
    if (status === 0) {
      return 'grey'
    } else if (status === 4) {
      return 'green'
    } else {
      let i = item.approval.findIndex(x => x.approvers.findIndex(y => y.isApproved === false) >= 0);
      if (isCurrentStep) {
        if (i >= 0) return 'yellow'
        else return 'green'
      } else {
        if (i >= 0) {
          return 'grey'
        } else {
          return 'green'
        }
      }
    }
  }

  function getColorInGroupStep(item, isCurrentStep) {
    if (status === 0) {
      return 'grey'
    } else if (status === 4) {
      return 'green'
    } else {
      let i = item.approvers.findIndex(x => x.isApproved === false);
      if (isCurrentStep) {
        if (i >= 0) return 'yellow'
        else return 'green'
      } else {
        if (i >= 0) {
          return 'grey'
        } else {
          return 'green'
        }
      }
    }
  }

  function getColorUserStep(item, isCurrentStep) {
    if (status === 0) {
      return 'grey'
    } else if (status === 4) {
      return 'green'
    } else {
      if (isCurrentStep) {
        if (!item.isApproved) return 'yellow'
        else return 'green'
      } else {
        if (!item.isApproved) {
          return 'grey'
        } else {
          return 'green'
        }
      }
    }
  }

}

const mapStateToProps = (state) => ({
})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Approvers)
